import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { getFullUrl } from 'hubspot-url-utils';
import { getI18nLangLocale } from 'pricing-pages-lib/utils/languageUtils';
import { getIsQAProxy } from '../utils/proxyUtils';
export const getBusinessObjectives = ({
  highlightedProducts,
  highlightedFeatureType
}) => {
  const i18nLangLocale = getI18nLangLocale();
  return noAuthHttp.get(`${getFullUrl('app-api', getIsQAProxy() ? {
    envOverride: 'qa'
  } : {})}/feature/store/v1/business-objectives/by-api-names`, {
    query: {
      productApiNames: highlightedProducts,
      highlightedFeatureType,
      i18nLangLocale
    }
  });
};